import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'
import {
  calculateResponsiveSize,
  calculateMobileResponsiveSize,
  mediaMax
} from 'styles/media-queries'
import HeaderLogo from 'icons/logo-mini.svg'
import PhoneLogo from 'icons/phone.svg'

export const Wrapper = styled.header`
  height: ${calculateResponsiveSize(40)};
  background: var(--beige);
  z-index: 11;
  position: fixed;
  top: 0;
  width: 100%;
  border-bottom: 1px solid var(--brick);
  display: flex;
  align-items: center;
  padding: 0 ${calculateResponsiveSize(20)};
  opacity: 1;
  transition: opacity 0s;
  &.hide {
    opacity: 0;
  }
  & .right {
    margin-left: auto;
  }

  ${mediaMax('mobile')} {
    height: ${calculateMobileResponsiveSize(40)};
    padding: 0 ${calculateMobileResponsiveSize(26)};
    z-index: 11;
    & .right {
      margin-left: auto;
    }
    &.no-header {
      display: none;
    }
  }
`

export const Logo = styled((props) => <Link {...props} />)`
  mask-position: center center;
  mask-repeat: no-repeat;
  mask-size: contain;

  -webkit-mask-position: center center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-size: contain;
  background: var(--brick);
  mask-image: url(${HeaderLogo});
  -webkit-mask-image: url(${HeaderLogo});
  width: ${calculateResponsiveSize(117)};
  height: 100%;

  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  &:hover {
    background: var(--flower);
  }
  ${mediaMax('mobile')} {
    width: ${calculateMobileResponsiveSize(80.66)};
    height: 100%;
    &:hover {
      background: var(--brick);
    }
  }
`

export const LinkItem = styled((props) => <Link {...props} />)`
  font-family: 'Mr Eaves XL Mod OT';
  font-weight: 700;
  font-size: ${calculateResponsiveSize(15)};
  line-height: 120%;
  letter-spacing: 0.12em;
  text-align: center;
  text-transform: uppercase;

  &:hover {
    color: var(--flower);
  }
  ${mediaMax('mobile')} {
    font-size: ${calculateMobileResponsiveSize(12)};

    line-height: 130%;
    letter-spacing: 0.1em;
    &.availability {
      display: none;
    }
  }
`
export const Phone = styled.a`
  mask-position: center center;
  mask-repeat: no-repeat;
  mask-size: contain;

  -webkit-mask-position: center center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-size: contain;
  background: var(--brick);
  mask-image: url(${PhoneLogo});
  -webkit-mask-image: url(${PhoneLogo});
  display: none;

  ${mediaMax('mobile')} {
    width: ${calculateMobileResponsiveSize(15.85)};
    height: ${calculateMobileResponsiveSize(15.85)};
    display: flex;
  }
`
